<template>
  <div>
    <s-crud
      title="Lugar de Producción / Fundo Agrícola"
      @rowSelected="rowSelected($event)"
      :config="configCrud"
      @save="save($event)"
      edit
      add
      remove
      :filter="filter"
      ref="crud"
      search-input
    >
      <template v-slot:options>
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              text
              small
              @click="showImportModal = true"
            >
              <v-icon>mdi-file-excel</v-icon> 
            </v-btn>
          </template>
          <span>Actualización Masiva de Lotes (Excel)</span>
        </v-tooltip>
      </template>

      <template v-slot:filter>
        <v-container>
          <v-row>
            <v-col cols="12" md="5" lg="3">
              <s-selected-zona
                clearable
                v-model="filter.ZonID"
                full
                noDefault
                label="Zona"
              >
              </s-selected-zona>
            </v-col>
            <v-col cols="12" md="5" lg="3">
              <s-select-definition
                clearable
                v-model="filter.TypePartner"
                :def="1598"
                label="Tipo de Socio"
              ></s-select-definition>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template slot-scope="props">
        <v-container class="pb-3">
          <v-row justify="center">
            <v-col cols="12" class="s-col-form" md="5" lg="3">
              <s-text v-model="props.item.FagName" label="Fundo Agrícola" autofocus>
              </s-text>
            </v-col>
            <v-col cols="12" class="s-col-form" md="7" lg="3">
              <s-text v-model="props.item.FagAddress" label="Dirección" />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-text
                v-model="props.item.FagHectares"
                label="Hectareas (m)"
                ref="FagHectares"
                decimal
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="3" md="2" lg="2">
              <s-select-definition
                v-model="props.item.FagStatus"
                :def="1225"
                label="Estado"
              ></s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="3" md="3" lg="2">
              <s-select-definition
                v-model="props.item.TypePartner"
                :def="1598"
                label="Tipo de Socio"
              ></s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form" md="6" lg="4">
              <s-text v-model="props.item.FagPlotReference" label="Ref-Parcela" />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-selected-zona
                :text="props.item.ZonIDText"
                v-model="props.item.ZonID"
                full
                label="Zona"
              >
              </s-selected-zona>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-selected-subzona
                v-if="props.item.ZonID"
                :ZonID="props.item.ZonID"
                :text="props.item.SzoIDText"
                label="Sub-Zona"
                v-model="props.item.SzoID"
                ref="SzoID"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-selected-sector
                :text="props.item.StrIDText"
                v-model="props.item.StrID"
                full
                label="Sector"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-selected-subsector
                v-if="props.item.StrID"
                :StrID="props.item.StrID"
                :text="props.item.SstrIDText"
                label="Sub-Sector"
                v-model="props.item.SstrID"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-text
                v-model="props.item.FagLatitude"
                label="Latitud"
                ref="FagLatitude"
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-text v-model="props.item.FagLength" label="Longitud" ref="FagLength" />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:FagStatus="{ row }">
        <v-chip
          style="margin: 0px"
          x-small
          :color="row.FagStatus == 1 ? 'success' : 'error'"
        >
          {{ row.FagStatus == 1 ? "Activo" : "Inactivo" }}
        </v-chip>
      </template>

      <!-- OJITO DE RESPONSABLE DE COBRAR -->
      <template v-slot:ViewMapFarm="{ row }">
        <v-btn x-small color="info" block outlined @click="openFarmMap(row)">
          <v-icon style="font-size: 16px !important">mdi mdi-google-maps</v-icon>
        </v-btn>
      </template>
      <!-- OJITO DE RESPONSABLE DE COBRAR -->
      <template v-slot:RespCollecting="{ row }">
        <v-btn
          icon
          color="light-blue darken-4"
          v-if="row.RespCollecting == 1"
          small
          @click="showModal"
        >
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>

      <!-- OJITO DE SUPERVISOR -->
      <template v-slot:RespSupervisor="{ row }">
        <v-btn
          icon
          color="light-blue darken-4"
          v-if="row.RespSupervisor == 1"
          small
          @click="showModalSuperv"
        >
          <v-icon> mdi-clipboard-account</v-icon>
        </v-btn>
      </template>
    </s-crud>

    <s-agricultural-farm-responsible-supervisor
      :dialogSuperv="dialogSuperv"
      :FagID="FagID"
      @hideModal="hideModalSuperv"
      @recharge="rechargeSuperv"
      @closeSuperv="closeSuperv"
    />

    <v-dialog v-model="showFarmMapModal" fullscreen persistent>
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Seleccionar ubicación del Fundo</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="showFarmMapModal = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="map-container">
            <l-map
              ref="farmMap"
              :zoom="farmMapZoom"
              :center="farmMapCenter"
              @ready="onFarmMapReady"
              @click="onFarmMapClick"
            >
              <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
              <l-marker
                v-if="currentFarm && currentFarm.FagLatitude && currentFarm.FagLength"
                :lat-lng="[
                  parseFloat(currentFarm.FagLatitude),
                  parseFloat(currentFarm.FagLength),
                ]"
              />
            </l-map>
          </div>
          <div class="d-flex mt-2" style="gap: 8px; align-items: center; flex-wrap: wrap">
            <v-text-field
              dense
              outlined
              hide-details
              label="Latitud"
              :value="currentFarm?.FagLatitude"
              readonly
              style="max-width: 200px"
            />
            <v-text-field
              dense
              outlined
              hide-details
              label="Longitud"
              :value="currentFarm?.FagLength"
              readonly
              style="max-width: 200px"
            />
            <v-text-field
              dense
              outlined
              hide-details
              label="Coordenadas (DMS)"
              v-model="coordInputFarm"
              style="max-width: 320px"
            />
            <v-btn small outlined color="primary" class="ml-2" @click="goToCoordsFarm">
              <v-icon left small>mdi-crosshairs</v-icon> Ir
            </v-btn>
            <v-spacer />
            <v-btn
              small
              outlined
              color="accent"
              @click="useMyLocationFarm"
              :loading="locating"
            >
              <v-icon left small>mdi-crosshairs-gps</v-icon> Planta
            </v-btn>
            <v-btn
              v-if="!hasFarmGeom"
              small
              outlined
              color="indigo"
              class="ml-2"
              @click="startFarmDraw"
            >
              <v-icon left small>mdi-vector-polygon</v-icon> Dibujar polígono
            </v-btn>
            <v-btn
              v-else
              small
              outlined
              color="orange"
              class="ml-2"
              @click="startFarmEdit"
            >
              <v-icon left small>mdi-square-edit-outline</v-icon> Editar polígono
            </v-btn>
            <v-btn
              small
              color="green"
              class="ml-2"
              :disabled="!farmGeom"
              @click="saveFarmGeometry"
            >
              <v-icon left small>mdi-content-save</v-icon> Guardar polígono
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showFarmMapModal = false">Cerrar</v-btn>
          <v-btn color="primary" @click="confirmFarmLocation">Guardar punto</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <farm-lot-import-modal
      v-model="showImportModal"
      @imported="onLotsImported"
    />

    <AlertSunshine :dialog="loading" />
  </div>
</template>
<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import AlertSunshine from "@/components/Utils/AlertSunshine.vue";
import _sAgriculturalFarms from "@/services/Technicalassistance/AgriculturalFarmsService";
import sSelectedZona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedZona";
import sSelectedSubzona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedSubzona";
import sSelectedSector from "@/components/TecnicalAssistence/MaintainerSector/sSelectedSector";
import sSelectedSubsector from "@/components/TecnicalAssistence/MaintainerSector/sSelectedSubsector";
import SText from "../../../components/Utils/SText.vue";
import SAgriculturalFarmResponsibleSupervisor from "../../../components/TecnicalAssistence/ProducersFarms/sAgriculturalFarmResponsibleSupervisor.vue";
import FarmLotImportModal from "./FarmLotImportModal.vue";

// Fix iconos Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  name: "RequirementServiceFarms",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    sSelectedSector,
    sSelectedSubzona,
    sSelectedSubsector,
    sSelectedZona,
    AlertSunshine,
    SText,
    SAgriculturalFarmResponsibleSupervisor,
    FarmLotImportModal,
  },
  props: {
    parentID: { type: Number, default: 0 },
    PrsID: { type: Number, default: 0 },
    isAdmin: { type: Boolean, default: false },
  },
  data: () => ({
    filter: { PrdID: 0, ZonID: null },
    plant: { lat: -4.9005, lng: -80.3314 },
    dialog: false,
    dialogSuperv: false,
    showImportModal: false,
    FagID: 0,
    ZonID: 0,
    StrID: 0,
    loading: false,
    // Mapa para seleccionar coordenadas del Fundo
    showFarmMapModal: false,
    currentFarm: null,
    farmMapCenter: [-5.19449, -80.63282],
    farmMapZoom: 15,
    tileUrl: "https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.jpg",
  tileAttribution: "© Stadia Maps | © OpenStreetMap",
  locating: false,
  coordInputFarm: "",
    farmGeom: null,
    farmDrawControl: null,
    farmGeomLayer: null,
    farmEditGroup: null,
    // Solo se podrá editar el PRIMER polígono
    firstFarmLayer: null,
    openingFarmMap: false,
    // Punto de vista previa (coordenadas pegadas), independiente del punto oficial del fundo
    previewPointLayer: null,
    previewPoint: null, // { lat, lon }
  // Capa para mostrar polígonos cercanos según lat/lon
  nearbyFarmsLayer: null,

    ObjSubzona: {
      subzonaObj: null,
    },
    ObjSubsector: {
      subsectorObj: null,
    },
  }),
  computed: {
    hasFarmGeom() {
      // Solo consideramos geometría si hay una capa que coincide con el FagID actual
      return !!this.firstFarmLayer;
    },
    configCrud() {
      return {
        model: {
          ViewMapFarm: "",
          FagID: "ID",
          PrsID: "int",
          PrdID: "int",
          ZonID: "int",
          SzoID: "int",
          ZonIDText: "int",
          SzoIDText: "int",
          StrID: "int",
          SstrID: "int",
          PrdCardName: "string",
          TypePrice: "int",
          FagStatus: "int",
          TypeCondition: "int",
          FagCode: "string",
          FagName: "string",
          FagHectares: "decimal",
          FagCodeOrganic: "string",
          RespCollecting: "int",
          RespSupervisor: "int",
        },
        service: _sAgriculturalFarms,
        filter: {
          ZonID: null,
          TypePartner: null,
        },
        headers: this.isAdmin
          ? [
              { text: "Maps", value: "ViewMapFarm", width: 70 },
              { text: "ID", value: "FagID" },
              { text: "Estado", value: "FagStatus" },
              { text: "Fundo", value: "FagName", width: 300 },
              { text: "Supervisor", value: "RespSupervisor", width: 50, align: "center" },
              { text: "Zona", value: "ZonIDText", width: 120 },
              { text: "Sub-Zona", value: "SzoIDText", width: 140 },
              { text: "Latitud", value: "FagLatitude" },
              { text: "Longitud", value: "FagLength" },
              { text: "Cod. Organico", value: "FagCodeOrganic", width: 120 },
              { text: "Hectareas", value: "FagHectares" },
              { text: "Tipo Socio", value: "TypePartnerName" },
            ]
          : [
              { text: "Maps", value: "ViewMapFarm", width: 70 },
              { text: "ID", value: "FagID", sortable: false },
              { text: "Estado", value: "FagStatus", sortable: false },
              { text: "Fundo", value: "FagName", sortable: false, width: 300 },
              { text: "Supervisor", value: "RespSupervisor", width: 50, align: "center" },
              { text: "Zona", value: "ZonIDText" },
              { text: "Sub-Zona", value: "SZoIDText" },
              { text: "Tipo Socio", value: "TypePartnerName" },
            ],
      };
    },
  },
  methods: {
    onLotsImported() {
      // Emit un evento al padre (ProducersFarms_G) para que si es necesario recargue FarmLot, o al propio componente hijo FarmLot mediante un bus/metodo
      this.$emit("updateTableLot"); 
      // Si FarmLot está cargado en el padre o si Farms sabe si está el lote
    },
    // --- Helpers: punto en polígono (ray casting) ---
    _pointInRing(lat, lng, ring) {
      try {
        let inside = false;
        for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
          const xi = ring[i].lat, yi = ring[i].lng;
          const xj = ring[j].lat, yj = ring[j].lng;
          const intersect = yi > lng !== yj > lng && lat < ((xj - xi) * (lng - yi)) / (yj - yi + 0.0) + xi;
          if (intersect) inside = !inside;
        }
        return inside;
      } catch (_) {
        return false;
      }
    },
    _pointInLayer(lat, lng, layer) {
      try {
        const latlngs = layer.getLatLngs && layer.getLatLngs();
        if (!latlngs || latlngs.length === 0) return false;
        // Normalizar a array de anillos: [ [LatLng,...], [hole...], ... ]
        const normalize = (arr) => {
          // MultiPolygon: [[[...]], [[...]]]
          if (Array.isArray(arr[0]) && Array.isArray(arr[0][0])) return arr; // ya multi
          // Polygon: [[...]] o [...]
          return Array.isArray(arr[0]) ? [arr] : [[arr]];
        };
        const polys = normalize(latlngs);
        for (const poly of polys) {
          const outer = poly[0] || [];
          if (outer.length === 0) continue;
          const insideOuter = this._pointInRing(lat, lng, outer);
          if (!insideOuter) continue;
          // Si está dentro del anillo exterior, verificar que NO esté dentro de algún hoyo
          let inHole = false;
          for (let h = 1; h < poly.length; h++) {
            if (this._pointInRing(lat, lng, poly[h] || [])) { inHole = true; break; }
          }
          if (!inHole) return true;
        }
        return false;
      } catch (_) {
        return false;
      }
    },
    _isPointInsideFarm(lat, lng) {
      try {
        const target = this.firstFarmLayer;
        if (!target) return true; // Si no hay polígono propio del fundo, permitir
        return this._pointInLayer(lat, lng, target);
      } catch (_) { return true; }
    },
    _setFarmPointIfValid(lat, lng) {
      // Si existe polígono, exigir que el punto caiga dentro
      if (this.hasFarmGeom) {
        const inside = this._isPointInsideFarm(lat, lng);
        if (!inside) {
          return false; // No mostrar mensaje aquí, se mostrará desde donde se llama
        }
      }
      
      // Establecer el punto
      if (this.currentFarm) {
        this.currentFarm.FagLatitude = Number(lat).toFixed(6);
        this.currentFarm.FagLength = Number(lng).toFixed(6);
      }
      return true;
    },
    // --- Vista previa en el mapa (siempre muestra, aunque esté fuera del polígono) ---
    _updatePreviewPoint(lat, lon, opts = {}) {
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (!map || isNaN(lat) || isNaN(lon)) return;
        if (this.previewPointLayer) {
          try { map.removeLayer(this.previewPointLayer); } catch (_) {}
          this.previewPointLayer = null;
        }
        const color = opts.color || '#03a9f4';
        const text = opts.text || 'Vista previa';
        const cm = L.circleMarker([lat, lon], {
          radius: 7,
          color,
          weight: 2,
          fillColor: color,
          fillOpacity: 0.9,
          opacity: 0.9,
        }).addTo(map);
        try { cm.bindTooltip(text, { permanent: false, direction: 'top', offset: [0, -8] }); } catch (_) {}
        this.previewPointLayer = cm;
        this.previewPoint = { lat, lon };
      } catch (_) {}
    },
    _clearPreviewPoint() {
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (map && this.previewPointLayer) {
          try { map.removeLayer(this.previewPointLayer); } catch (_) {}
        }
        this.previewPointLayer = null;
        this.previewPoint = null;
      } catch (_) {
        this.previewPointLayer = null;
        this.previewPoint = null;
      }
    },

    // Normaliza/valida coordenadas del fundo delegando al util global ($fun)
    _normalizeFarmCoords(item) {
      return this.$fun && this.$fun.normalizeCoords
        ? this.$fun.normalizeCoords(item, 'FagLatitude', 'FagLength', 6)
        : true;
    },
    // --- Cargar y pintar polígonos cercanos (solo visualización) ---
    async _loadNearbyFarms(lat, lon, radius = 1000) {
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (!map || isNaN(lat) || isNaN(lon)) return;
        // limpiar capa anterior
        if (this.nearbyFarmsLayer) {
          try { map.removeLayer(this.nearbyFarmsLayer); } catch (_) {}
          this.nearbyFarmsLayer = null;
        }
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        const { data: fc } = await _sAgriculturalFarms.getNearbyFarmsGeoJSON(lat, lon, radius, uid);
        if (!fc) return;
        // Pintar con estilo diferenciado (morado semitransparente, línea discontinua)
        this.nearbyFarmsLayer = L.geoJSON(fc, {
          style: () => ({
            color: '#7e57c2',
            fillColor: '#b39ddb',
            fillOpacity: 0.15,
            weight: 2,
            dashArray: '6,4',
          }),
          onEachFeature: (feature, layer) => {
            try {
              // Obtener propiedades de este polígono cercano
              const props = feature.properties || {};
              const farmName = props.FagName || props.Name || props.name || 'Fundo cercano';
              const fid = props.FagID ?? props.fagid ?? props.Id ?? props.ID ?? props.id;
              const zona = props.ZonIDText || props.Zona || props.zona || '';
              
              // Calcular área y perímetro
              let areaM2 = 0;
              let perimeterM = 0;
              const latlngs = layer.getLatLngs();
              const rings = Array.isArray(latlngs[0]) 
                ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                : [[latlngs]];
              
              rings.forEach(polygon => {
                const outerRing = polygon[0] || polygon;
                if (outerRing && outerRing.length > 0) {
                  // Calcular área
                  const R = 6371000;
                  let sum = 0;
                  for (let i = 0; i < outerRing.length - 1; i++) {
                    const p1 = outerRing[i];
                    const p2 = outerRing[i + 1];
                    const lat1 = p1.lat * Math.PI / 180;
                    const lat2 = p2.lat * Math.PI / 180;
                    const lng1 = p1.lng * Math.PI / 180;
                    const lng2 = p2.lng * Math.PI / 180;
                    sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                  }
                  areaM2 += Math.abs(sum * R * R / 2);
                  
                  // Calcular perímetro
                  for (let i = 0; i < outerRing.length - 1; i++) {
                    perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                  }
                  if (outerRing.length > 0) {
                    perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                  }
                }
              });
              
              const areaHa = (areaM2 / 10000).toFixed(2);
              const perimeterKm = (perimeterM / 1000).toFixed(3);
              
              const parts = [
                `<strong>${farmName} (Cercano)</strong>`,
                fid ? `ID: ${fid}` : '',
                zona ? `Zona: ${zona}` : '',
                `<strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)`,
                `<strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)`
              ].filter(Boolean);
              
              const html = parts.join('<br/>');
              layer.bindTooltip(html, { sticky: true });
            } catch (_) {}
          }
        }).addTo(map);
        try { this.nearbyFarmsLayer.bringToBack(); } catch (_) {}
      } catch (err) {
        this.$fun && this.$fun.toast && this.$fun.toast('No se pudieron cargar polígonos cercanos', 'warning');
      }
    },
    // --- Parser de coordenadas (DMS/decimal) ---
    _parseDMS(val) {
      try {
        if (val == null) return NaN;
        const s = String(val).trim();
        if (s.length === 0) return NaN;
        const upper = s.toUpperCase();
        const dir = (upper.match(/[NSEW]/) || [null])[0];
        const m = upper.match(/(-?\d+(?:\.\d+)?)\s*(?:[°º])?\s*(\d+(?:\.\d+)?)?'?\s*(\d+(?:\.\d+)?)?"?/);
        let deg = 0, min = 0, sec = 0;
        if (m) {
          deg = parseFloat(m[1] || 0);
          min = parseFloat(m[2] || 0);
          sec = parseFloat(m[3] || 0);
          let sign = 1;
          if (deg < 0) sign = -1;
          const valDec = Math.abs(deg) + (min || 0) / 60 + (sec || 0) / 3600;
          let out = sign * valDec;
          if (dir === 'S' || dir === 'W') out = -Math.abs(valDec);
          if (dir === 'N' || dir === 'E') out = Math.abs(valDec);
          return out;
        }
        const num = parseFloat(s.replace(',', '.'));
        return isNaN(num) ? NaN : num;
      } catch (_) { return NaN; }
    },
    _parseCoordPair(input) {
      try {
        if (!input) return null;
        let s = String(input).trim();
        if (!s) return null;
        s = s.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
        const hasLat = /[NS]/i.test(s), hasLon = /[EW]/i.test(s);
        if (hasLat && hasLon) {
          const latIdx = s.search(/[NS]/i);
          if (latIdx > -1) {
            const latToken = s.slice(0, latIdx + 1).trim();
            const rest = s.slice(latIdx + 1).trim();
            const lonIdx = rest.search(/[EW]/i);
            const lonToken = lonIdx > -1 ? rest.slice(0, lonIdx + 1).trim() : rest;
            const lat = this._parseDMS(latToken);
            const lon = this._parseDMS(lonToken);
            if (isNaN(lat) || isNaN(lon)) return null;
            return { lat, lon };
          }
        }
        const nums = s.match(/-?\d+(?:\.\d+)?/g) || [];
        if (nums.length >= 2) {
          const lat = parseFloat(nums[0]);
          const lon = parseFloat(nums[1]);
          if (!isNaN(lat) && !isNaN(lon)) return { lat, lon };
        }
        return null;
      } catch (_) { return null; }
    },
    goToCoordsFarm() {
      const parsed = this._parseCoordPair(this.coordInputFarm);
      if (!parsed) {
        this.$fun && this.$fun.toast && this.$fun.toast('❌ Formato de coordenadas inválido', 'warning');
        return;
      }
      const { lat, lon } = parsed;
      
      // Validar si hay polígono
      const inside = this.hasFarmGeom ? this._isPointInsideFarm(lat, lon) : true;
      
      // Mostrar vista previa con color según validación
      this._updatePreviewPoint(lat, lon, {
        color: inside ? '#4CAF50' : '#F44336',
        text: inside ? '✓ Coordenada válida (dentro)' : '✗ Coordenada fuera del polígono'
      });
      
      // Mensaje según validación
      if (this.hasFarmGeom) {
        if (inside) {
          this.$fun && this.$fun.toast && this.$fun.toast(
            '✓ Coordenada válida. Haz clic en "Guardar punto" para confirmar.', 
            'success'
          );
        } else {
          this.$fun && this.$fun.alert && this.$fun.alert(
            '⚠️ La coordenada ingresada está FUERA del polígono del fundo. Por favor ingresa coordenadas dentro del área del polígono (mostrado en blanco).', 
            'warning'
          );
        }
      } else {
        this.$fun && this.$fun.toast && this.$fun.toast(
          '📍 Vista previa de coordenadas. Haz clic en "Guardar punto" para confirmar.', 
          'info'
        );
      }
      
      this.farmMapCenter = [lat, lon];
      this.farmMapZoom = 18;
      // Cargar polígonos cercanos a esta coordenada
      this._loadNearbyFarms(lat, lon, 1000);
    },
    resetFarmMapState() {
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (map) {
          try {
            map.off(L.Draw.Event.CREATED);
          } catch (_) {}
          try {
            map.off(L.Draw.Event.EDITED);
          } catch (_) {}
          try {
            map.off("contextmenu");
          } catch (_) {}
        }
        if (map && this.farmDrawControl) {
          try {
            map.removeControl(this.farmDrawControl);
          } catch (_) {}
        }
        this.farmDrawControl = null;
        if (map && this.farmGeomLayer) {
          try {
            map.removeLayer(this.farmGeomLayer);
          } catch (_) {}
        }
        this.farmGeomLayer = null;
        if (map && this.farmEditGroup) {
          try {
            map.removeLayer(this.farmEditGroup);
          } catch (_) {}
        }
        this.farmEditGroup = null;
        if (map && this.previewPointLayer) {
          try { map.removeLayer(this.previewPointLayer); } catch (_) {}
        }
        this.previewPointLayer = null;
        this.previewPoint = null;
        if (map && this.nearbyFarmsLayer) {
          try { map.removeLayer(this.nearbyFarmsLayer); } catch (_) {}
        }
        this.nearbyFarmsLayer = null;
        this.farmGeom = null;
        this.firstFarmLayer = null;
      } catch (_) {}
    },
    openFarmMap(item) {
      this.currentFarm = item;
      this.coordInputFarm = "";
      this._clearPreviewPoint();
      // reset estado previo para evitar bloqueos al cambiar de item
      this.resetFarmMapState();
      this.openingFarmMap = true;
      const toDecimal = (s) => {
        if (s == null) return NaN;
        if (typeof s === "number") return s;
        const str = String(s).trim();
        if (!str.includes("°") && !/[NSEWnsew]/.test(str)) return parseFloat(str);
        const re = /([\d.]+)°\s*([\d.]+)?'?\s*([\d.]+)?"?\s*([NSEWnsew-])?/;
        const m = str.match(re);
        if (!m) return parseFloat(str);
        const deg = parseFloat(m[1] || 0),
          min = parseFloat(m[2] || 0),
          sec = parseFloat(m[3] || 0);
        let sign = 1;
        if (/S|s|W|w|-/.test(str)) sign = -1;
        return sign * (deg + min / 60 + sec / 3600);
      };
      const lat = toDecimal(item.FagLatitude),
        lon = toDecimal(item.FagLength);
      if (!isNaN(lat) && !isNaN(lon)) {
        // Normaliza para que los inputs muestren decimales
        this.currentFarm.FagLatitude = Number(lat).toFixed(6);
        this.currentFarm.FagLength = Number(lon).toFixed(6);
        this.farmMapCenter = [lat, lon];
        this.farmMapZoom = 17;
      } else {
        this.farmMapCenter = [this.plant.lat, this.plant.lng];
        this.farmMapZoom = 15;
      }
      this.showFarmMapModal = true;
      this.$nextTick(() => {
        const p = this.onFarmMapReady();
        if (p && typeof p.finally === "function")
          p.finally(() => (this.openingFarmMap = false));
        else this.openingFarmMap = false;
      });
    },
    async onFarmMapReady() {
      this.loading = true;
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (map) setTimeout(() => map.invalidateSize(), 200);
        this.farmGeom = null;
        this.firstFarmLayer = null;
        
        // Cargar polígonos cercanos si hay coordenadas válidas
        if (this.currentFarm) {
          const toDecimal = (s) => {
            if (s == null) return NaN;
            if (typeof s === "number") return s;
            const str = String(s).trim();
            if (!str.includes("°")) return parseFloat(str);
            const re = /([\d.]+)°\s*([\d.]+)?'?\s*([\d.]+)?"?\s*([NSEWnsew-])?/;
            const m = str.match(re);
            if (!m) return parseFloat(str);
            const deg = parseFloat(m[1] || 0),
              min = parseFloat(m[2] || 0),
              sec = parseFloat(m[3] || 0);
            let sign = 1;
            if (/S|s|W|w|-/.test(str)) sign = -1;
            return sign * (deg + min / 60 + sec / 3600);
          };
          const lat = toDecimal(this.currentFarm.FagLatitude);
          const lon = toDecimal(this.currentFarm.FagLength);
          if (!isNaN(lat) && !isNaN(lon)) {
            // Cargar fundos cercanos en un radio de 1000m
            await this._loadNearbyFarms(lat, lon, 1000);
          }
        }
        
        // Cargar geometría existente del fundo
        if (this.currentFarm && this.currentFarm.FagID && map) {
          const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
          const { data: fc } = await _sAgriculturalFarms.getFarmGeometryGeoJSON(
            this.currentFarm.FagID,
            uid
          );

          // console.log("FC FUNDO GEOJSON:", fc);

          // limpiar capa anterior siempre
          if (this.farmGeomLayer) {
            try {
              map.removeLayer(this.farmGeomLayer);
            } catch (_) {}
            this.farmGeomLayer = null;
          }
          if (this.farmEditGroup) {
            try {
              map.removeLayer(this.farmEditGroup);
            } catch (_) {}
            this.farmEditGroup = null;
          }
          const hasFeatures = !!(
            fc &&
            ((fc.type === "FeatureCollection" && fc.features && fc.features.length > 0) ||
              fc.type === "Feature" ||
              fc.type === "Polygon" ||
              fc.type === "MultiPolygon")
          );
          if (hasFeatures) {
            // Pintar polígonos del fundo, resaltando solo el que coincida con el FagID actual
            const currentId = Number(this.currentFarm?.FagID);
            this.firstFarmLayer = null;
            this.farmGeomLayer = L.geoJSON(fc, {
              onEachFeature: (feature, layer) => {
                const p = (feature && feature.properties) || {};
                const featureColor =
                  (p.color || p.Color) ||
                  (this.currentFarm && this.currentFarm.color) ||
                  "#1976d2";
                try {
                  layer.setStyle({ color: featureColor, fillColor: featureColor, weight: 2, fillOpacity: 0.2 });
                } catch (_) {}
                const fid = Number(p.FagID ?? p.fagid ?? p.Id ?? p.ID ?? p.id ?? p.FarmId ?? p.farmId);
                if (!isNaN(fid) && fid === currentId && !this.firstFarmLayer) {
                  try { layer.setStyle({ color: "#ffffff", fillColor: "#ffffff", weight: 2, fillOpacity: 0.35 }); } catch (_) {}
                  this.firstFarmLayer = layer;
                }
              },
            }).addTo(map);
            try {
              // Calcular área y perímetro para CADA polígono individualmente
              this.farmGeomLayer.eachLayer((poly) => {
                try {
                  // Obtener propiedades específicas de ESTE polígono
                  const props = poly.feature?.properties || {};
                  const fid = Number(props.FagID ?? props.fagid ?? props.Id ?? props.ID ?? props.id ?? props.FarmId ?? props.farmId);
                  
                  // Usar propiedades del polígono, y currentFarm como fallback solo si es el mismo ID
                  const n = props.FagName || props.Name || props.name || 
                           (fid && fid === Number(this.currentFarm?.FagID) ? this.currentFarm?.FagName : null) || 
                           `Fundo ${fid || ''}`;
                  
                  const haDb = props.FagHectares ?? props.Hectares ?? 
                              (fid && fid === Number(this.currentFarm?.FagID) ? this.currentFarm?.FagHectares : null);
                  
                  const zona = props.ZonIDText || props.Zona || props.zona || 
                              (fid && fid === Number(this.currentFarm?.FagID) ? this.currentFarm?.ZonIDText : null) || 
                              "";
                  
                  let areaM2 = 0;
                  let perimeterM = 0;
                  
                  const latlngs = poly.getLatLngs();
                  // Normalizar estructura (puede ser [[coords]] o [[[coords]]])
                  const rings = Array.isArray(latlngs[0]) 
                    ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                    : [[latlngs]];
                  
                  rings.forEach(polygon => {
                    const outerRing = polygon[0] || polygon;
                    if (outerRing && outerRing.length > 0) {
                      // Calcular área usando fórmula geodésica
                      const R = 6371000; // Radio de la Tierra en metros
                      let sum = 0;
                      for (let i = 0; i < outerRing.length - 1; i++) {
                        const p1 = outerRing[i];
                        const p2 = outerRing[i + 1];
                        const lat1 = p1.lat * Math.PI / 180;
                        const lat2 = p2.lat * Math.PI / 180;
                        const lng1 = p1.lng * Math.PI / 180;
                        const lng2 = p2.lng * Math.PI / 180;
                        sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                      }
                      areaM2 += Math.abs(sum * R * R / 2);
                      
                      // Calcular perímetro
                      for (let i = 0; i < outerRing.length - 1; i++) {
                        perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                      }
                      // Cerrar el polígono
                      if (outerRing.length > 0) {
                        perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                      }
                    }
                  });
                  
                  const areaHa = (areaM2 / 10000).toFixed(2);
                  const perimeterKm = (perimeterM / 1000).toFixed(3);
                  
                  const parts = [
                    `<strong>${n}</strong>`,
                    haDb != null ? `Hectáreas BD: ${Number(haDb).toFixed(2)} ha` : "",
                    `<strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)`,
                    `<strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)`,
                    zona ? `Zona: ${zona}` : "",
                  ].filter(Boolean);
                  const html = parts.join("<br/>");
                  
                  poly.bindTooltip(html, { 
                    sticky: true,
                    className: 'farm-polygon-tooltip'
                  });
                  poly.on("mouseover", () => {
                    try {
                      poly.openTooltip();
                    } catch (_) {}
                  });
                } catch (e) {
                  console.error("Error calculando área/perímetro del polígono:", e);
                }
              });
            } catch (_) {}
            this.farmEditGroup = L.featureGroup();
            const targetLayer =
              this.firstFarmLayer ||
              (this.farmGeomLayer &&
                this.farmGeomLayer.getLayers &&
                this.farmGeomLayer.getLayers()[0]);
            if (targetLayer) this.farmEditGroup.addLayer(targetLayer);
            map.addLayer(this.farmEditGroup);
            try {
              map.fitBounds(this.farmGeomLayer.getBounds(), { maxZoom: 18 });
            } catch (_) {}
          }
        }
        // anticlick para editar si existe polígono
        if (map) {
          map.off("contextmenu");
          map.on("contextmenu", () => {
            if (this.hasFarmGeom) this.startFarmEdit();
          });
        }
      } catch (_) {
      } finally {
        this.loading = false;
      }
    },
    onFarmMapClick(e) {
      if (!this.currentFarm) return;
      
      const lat = e.latlng.lat;
      const lng = e.latlng.lng;
      
      // Si hay polígono, validar que el punto esté dentro
      if (this.hasFarmGeom) {
        const inside = this._isPointInsideFarm(lat, lng);
        
        // Mostrar feedback visual temporal
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (map) {
          const marker = L.circleMarker([lat, lng], {
            radius: 8,
            color: inside ? '#4CAF50' : '#F44336',
            fillColor: inside ? '#4CAF50' : '#F44336',
            fillOpacity: 0.7,
            weight: 2
          }).addTo(map);
          
          // Mostrar tooltip
          const tooltipText = inside 
            ? '✓ Punto válido (dentro del polígono)' 
            : '✗ Punto fuera del polígono';
          marker.bindTooltip(tooltipText, { permanent: true, direction: 'top' }).openTooltip();
          
          // Remover después de 2 segundos
          setTimeout(() => {
            try { map.removeLayer(marker); } catch (_) {}
          }, 1000);
        }
        
        if (!inside) {
          this.$fun && this.$fun.toast && this.$fun.toast(
            "⚠️ El punto debe estar dentro del polígono del fundo", 
            "warning"
          );
          return;
        }
      }
      
      // Si pasa la validación, establecer el punto
      this._setFarmPointIfValid(lat, lng);
      this.$fun && this.$fun.toast && this.$fun.toast(
        "✓ Punto establecido correctamente", 
        "success"
      );
    },
    useMyLocationFarm() {
      if (!navigator.geolocation) return;
      this.locating = true;
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;
          
          // Si hay polígono, validar que la ubicación esté dentro
          if (this.hasFarmGeom) {
            const inside = this._isPointInsideFarm(lat, lon);
            
            if (!inside) {
              this.$fun && this.$fun.alert && this.$fun.alert(
                "Tu ubicación GPS está fuera del polígono del fundo. Por favor, coloca el punto manualmente haciendo clic dentro del polígono.",
                "warning"
              );
              // Centrar en la ubicación pero no establecer el punto
              this.farmMapCenter = [parseFloat(lat), parseFloat(lon)];
              this.farmMapZoom = 18;
              this.locating = false;
              
              // Mostrar marker rojo temporal para indicar ubicación GPS
              const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
              if (map) {
                const marker = L.circleMarker([lat, lon], {
                  radius: 10,
                  color: '#F44336',
                  fillColor: '#F44336',
                  fillOpacity: 0.5,
                  weight: 3
                }).addTo(map);
                marker.bindTooltip('📍 Tu ubicación GPS (fuera del polígono)', { 
                  permanent: true, 
                  direction: 'top' 
                }).openTooltip();
                
                setTimeout(() => {
                  try { map.removeLayer(marker); } catch (_) {}
                }, 5000);
              }
              return;
            }
          }
          
          // Si pasa la validación o no hay polígono, establecer el punto
          this._setFarmPointIfValid(lat, lon);
          this.farmMapCenter = [parseFloat(lat), parseFloat(lon)];
          this.farmMapZoom = 18;
          this.$fun && this.$fun.toast && this.$fun.toast(
            "✓ Ubicación GPS establecida correctamente", 
            "success"
          );
          this.locating = false;
        },
        (error) => {
          this.$fun && this.$fun.toast && this.$fun.toast(
            "No se pudo obtener tu ubicación GPS", 
            "error"
          );
          this.locating = false;
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
      );
    },
    async confirmFarmLocation() {
      try {
        if (!this.currentFarm || !this.currentFarm.FagID) {
          this.showFarmMapModal = false;
          return;
        }
        // Preferir la vista previa si existe
        let lat, lng;
        if (this.previewPoint) {
          lat = parseFloat(this.previewPoint.lat);
          lng = parseFloat(this.previewPoint.lon);
          // reflejar normalización
          this.currentFarm.FagLatitude = Number(lat).toFixed(6);
          this.currentFarm.FagLength = Number(lng).toFixed(6);
        } else {
          // normalizar entradas individuales (pueden venir en DMS)
          const tmp = {
            FagLatitude: this.currentFarm.FagLatitude,
            FagLength: this.currentFarm.FagLength,
          };
          if (!this._normalizeFarmCoords(tmp)) {
            this.$fun && this.$fun.toast && this.$fun.toast('Coordenadas inválidas', 'warning');
            return;
          }
          lat = parseFloat(String(tmp.FagLatitude).replace(',', '.'));
          lng = parseFloat(String(tmp.FagLength).replace(',', '.'));
          this.currentFarm.FagLatitude = tmp.FagLatitude;
          this.currentFarm.FagLength = tmp.FagLength;
        }
        if (isNaN(lat) || isNaN(lng)) {
          this.showFarmMapModal = false;
          return;
        }
        // Validar punto dentro del polígono si existe
        if (!this._isPointInsideFarm(lat, lng)) {
          this.$fun && this.$fun.alert && this.$fun.alert("El punto está fuera del polígono del fundo", "warning");
          return;
        }
        // Actualizar el punto oficial con la vista previa válida (si existía)
        if (this.previewPoint) {
          this.currentFarm.FagLatitude = Number(lat).toFixed(6);
          this.currentFarm.FagLength = Number(lng).toFixed(6);
        }
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        await _sAgriculturalFarms.refreshCacheFarmPoint(this.currentFarm, uid);
      } catch (e) {
        // console.error("Actualizar punto fundo", e);
      }
      this._clearPreviewPoint();
      this.showFarmMapModal = false;
    },
    startFarmDraw() {
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (!map) return;
        if (this.farmDrawControl) {
          try {
            map.removeControl(this.farmDrawControl);
          } catch (_) {}
        }
        this.farmGeom = null;
        this.farmDrawControl = new L.Control.Draw({
          draw: {
            polygon: { showArea: true, allowIntersection: false },
            rectangle: false,
            polyline: false,
            circle: false,
            marker: false,
            circlemarker: false,
          },
          edit: false,
        });
        map.addControl(this.farmDrawControl);
        const onCreated = (e) => {
          try {
            const gj = e.layer && e.layer.toGeoJSON ? e.layer.toGeoJSON() : null;
            this.farmGeom = gj ? gj.geometry : null;
            // Mostrar capa dibujada
            if (this.farmGeomLayer) {
              try {
                map.removeLayer(this.farmGeomLayer);
              } catch (_) {}
              this.farmGeomLayer = null;
            }
            this.farmGeomLayer = L.geoJSON(gj).addTo(map);
            try {
              map.fitBounds(this.farmGeomLayer.getBounds(), { maxZoom: 19 });
            } catch (_) {}
          } catch (_) {}
          map.off(L.Draw.Event.CREATED, onCreated);
          try {
            map.removeControl(this.farmDrawControl);
          } catch (_) {}
          this.farmDrawControl = null;
        };
        map.on(L.Draw.Event.CREATED, onCreated);
      } catch (_) {}
    },
    startFarmEdit() {
      try {
        const map = this.$refs.farmMap && this.$refs.farmMap.mapObject;
        if (!map) return;
        // si no hay grupo de edición, construirlo desde la capa actual
        if (!this.farmEditGroup && this.farmGeomLayer) {
          this.farmEditGroup = L.featureGroup();
          const targetLayer =
            this.firstFarmLayer ||
            (this.farmGeomLayer &&
              this.farmGeomLayer.getLayers &&
              this.farmGeomLayer.getLayers()[0]);
          if (targetLayer) this.farmEditGroup.addLayer(targetLayer);
          map.addLayer(this.farmEditGroup);
        }
        if (!this.farmEditGroup) return;
        if (this.farmDrawControl) {
          try {
            map.removeControl(this.farmDrawControl);
          } catch (_) {}
          this.farmDrawControl = null;
        }
        this.farmDrawControl = new L.Control.Draw({
          draw: false,
          edit: { featureGroup: this.farmEditGroup, edit: true, remove: false },
        });
        map.addControl(this.farmDrawControl);
        const onEdited = (e) => {
          try {
            e.layers.eachLayer((layer) => {
              const gj = layer.toGeoJSON();
              this.farmGeom = gj.geometry;
            });
          } catch (_) {}
          map.off(L.Draw.Event.EDITED, onEdited);
          try {
            map.removeControl(this.farmDrawControl);
          } catch (_) {}
          this.farmDrawControl = null;
        };
        map.on(L.Draw.Event.EDITED, onEdited);
      } catch (_) {}
    },
    async saveFarmGeometry() {
      try {
        if (!this.currentFarm || !this.currentFarm.FagID || !this.farmGeom) return;
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        await _sAgriculturalFarms.refreshCacheFarmGeometry(
          this.currentFarm.FagID,
          this.farmGeom,
          uid
        );
        this.$fun && this.$fun.toast && this.$fun.toast("Geometría guardada", "success");
        this.farmGeom = null;
        // recargar capa para edición
        this.$nextTick(this.onFarmMapReady);
      } catch (e) {
        // console.error("Guardar polígono fundo", e);
        this.$fun && this.$fun.alert("Error guardando polígono", "error");
      }
    },
    Initialize() {
      this.filter = { PrdID: this.parentID };
    },
    rowSelected(rows) {
      if (rows.length > 0) {
        this.$emit("rowSelected", rows);
        this.FagID = rows[0].FagID;
      }
    },
    //------- RESPONSABLE POR COBRAR---------------
    //MOSTRAR MODAL RESPONSABLE DE COBRAR
    showModal() {
      this.dialog = true;
    },
    // OCULTAR MODAL DE RESPONSABLE POR COBRAR
    hideModal() {
      this.dialog = false;
    },
    // REFRESCAR MODAL DEL RESPONSABLE POR COBRAR
    recharge() {
      this.$refs.crud.refresh();
    },
    // CERRAR MODAL DEL RESPONSABLE POR COBRAR
    close() {
      this.dialog = false;
    },

    //------- SUPERVISOR-----------------
    //MOSTRAR MODAL RESPONSABLE DE COBRAR
    showModalSuperv() {
      this.dialogSuperv = true;
    },
    // OCULTAR MODAL DE RESPONSABLE POR COBRAR
    hideModalSuperv() {
      this.dialogSuperv = false;
    },
    // REFRESCAR MODAL DEL RESPONSABLE POR COBRAR
    rechargeSuperv() {
      this.$refs.crud.refresh();
    },
    // CERRAR MODAL DEL SUPERVISOR
    closeSuperv() {
      this.dialogSuperv = false;
    },

    save(item) {
      item.PrdID = this.parentID;
      item.PrsID = this.PrsID;
      item.TypeCondition = 1;
      /* item.SzoID = this.ObjSubzona.SzoID;
      item.SstrID = this.ObjSubsector.SstrID; */

      if (item.FagName.length == 0) {
        this.$fun.alert("Registre Nombre de Fundo", "warning");
        return;
      }
      if (item.ZonID == 0) {
        this.$fun.alert("Selecciona un Cultivo", "warning");
      }
      if (item.SzoID == 0) {
        this.$fun.alert("Seleccione una Sub-Zona", "warning");
        return;
      }

      item.save();
    },

    input(item) {
      this.ZonID = item.ZonID;
      this.StrID = item.StrID;
    },
  } /* este watch estará a la escucha de los cambios que suceden en :parentID  7 */,
  watch: {
    parentID() {
      this.Initialize();
    },
    showFarmMapModal(val) {
      if (!val) {
        this.resetFarmMapState();
        this.openingFarmMap = false;
      }
    },
  },
  created() {
    this.filter = { PrdID: this.parentID };
  },
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: calc(100vh - 180px);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
</style>

<style>
.farm-polygon-tooltip {
  background-color: rgba(255, 255, 255, 0.95) !important;
  border: 2px solid #2196F3 !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  font-family: 'Roboto', Arial, sans-serif !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25) !important;
  color: #333 !important;
}

.farm-polygon-tooltip::before {
  border-top-color: #2196F3 !important;
}
</style>
